module.exports = __webpack_public_path__ + "img/poster_qrcode.f9f43ea9.png";